import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { uGetTimeArray } from '@appbase/util';
import api from '@reserve/api'
import { IEDate, uGetDateFormat, uGetDateFormat_UTC } from '@/modules/@appbase/util';
import { openReserveResourceTime } from '@reserve/popup-handler';
import { mapGetters, mapMutations } from 'vuex';
import * as types from '@reserve/store/types'

export interface EventArray{
    txt: string
    bf: reserve.CalendarItem | null
    af: reserve.CalendarItem | null
}
@Component({
    computed: mapGetters({
        selectedResources: types.SELECTED_RESOURCE_LIST,
    }),
    methods: {
        ...mapMutations({
            setLoading: types.CALENDAR_LOADING
        })
    }
})
export default class TimeLine  extends Vue {
@Prop({ type: Object }) resource!:reserve.DbResourceItem
@Prop({ type: Boolean, default: false }) isHeader!:boolean
@Prop({ type: String }) displayTooltip!:string
@Prop({ type: Date }) targetDate!:Date

    setLoading!: (payload: boolean) => void;
    selectedResources!: reserve.ResourceItemBase[];

    timeArray: reserve.TimelineItem[] = [];
    eventArray: EventArray[] = [];
    eventList: reserve.CalendarItem[] = [];

    startDate: string = new Date().toString();
    endDate: string = new Date().toString();

    tooltipTxt: string = '';
    tooltipIdx: number = -1;

    @Watch('selectedResources', {deep: true})
    onChangedSelectedResource(list: reserve.ResourceItemBase[]){
        this.setLoading(true)
        setTimeout(() => {
            this.setLoading(false)
        }, 100);
    }

    @Watch('targetDate')
    onChangedTargetDate(date: Date){
        if(!this.isHeader){
            this.startDate = uGetDateFormat_UTC('yyyy-MM-DDT00:00:00', IEDate(date));
            this.endDate = uGetDateFormat_UTC('yyyy-MM-DDT23:59:59', IEDate(date));
            this.getEventList();
        }
    }

    @Watch('displayTooltip')
    onChangedTooltipId(id: string){
        if(this.resource.uniqueId != id){
            this.tooltipIdx = -1
            this.tooltipTxt = ''
        }
    }

    get StyleLeftValue(){
        var target = (this.DisplayText.replace(/ \d{2}:\d{2}~\d{2}:\d{2}/,'').length)/3
        var length = Math.floor((target-1))
        return -(20*(length<=0?1:length));
    }
    
    get DisplayText(){
        return this.tooltipTxt
    }

    get ShowTooltip(){
        return this.resource.uniqueId == this.displayTooltip
    }

    getReservationStatus(){
        return this.eventArray.some(a=> a.af == null || a.bf == null)
    }

    setTooltipTxt(item: reserve.CalendarItem){
        var schedule = this.eventList.find(e=>e.id == item.id)
        if(schedule){
            var name = schedule.organizerName
            var duration = schedule.scheduleDuration.split(':')[0]
            var _start = schedule.start.split(' ')[1].substring(0,5)
            var _end = schedule.end.split(' ')[1].substring(0,5)
            // 시작일이 오늘보다 전이면
            if(new Date(schedule.start) < new Date(uGetDateFormat_UTC(`yyyy-MM-DDT06:00:00`, IEDate(this.targetDate)))){
                _start = '06:00'
            }
            // 일정 종료가 다음날이면
            if(new Date(schedule.end) > new Date(uGetDateFormat_UTC(`yyyy-MM-DDT21:00:00`, IEDate(this.targetDate)))){
                _end = '21:00'
            }
            this.tooltipTxt = `${name} ${_start}~${_end}`
        }
    }

    showTooltip(idx: number, item: reserve.CalendarItem){
        if(item == null) return;
        if(!this.ShowTooltip) this.$emit('resetTooltip',this.resource.uniqueId)
        this.tooltipIdx = this.tooltipIdx==idx? -1 : idx;
        this.setTooltipTxt(item);
    }

    onSelectDblClick(time: string, evt: reserve.CalendarItem | null, min: number){
        if(evt != null) return;
        let dblStartTime = IEDate(uGetDateFormat(`yyyy-MM-dd ${time}:${min}0:00`,this.targetDate));
        let dblEndTime = IEDate(uGetDateFormat(`yyyy-MM-dd ${time}:${min}0:00`,this.targetDate));
        dblEndTime.setMinutes(dblEndTime.getMinutes() + 30);
        openReserveResourceTime(this.resource.comCode, dblStartTime, dblEndTime, this.resource.itemStore, this.resource.address);
    }

    hasEvent(item: reserve.CalendarItem):boolean{
        return item!=null
    }

    getEventList(){
        api.resourceDb.getCalendarEventList({
            FolderID: this.resource.folderId,
            StartDate: this.startDate,
            EndDate: this.endDate
        }).then(res=>{
            if(res && res.length>0){
                this.eventList = res;
            }
        }).finally(()=>{
            this.setEventList()
        })
    }

    setEventList(){
        if(this.eventList.length>0){
            this.eventList
            .map(e=>{
                this.eventArray.forEach(a=>{
                    if(new Date(e.end) < new Date(this.startDate)){
                        return
                    }
                    if(new Date(e.start) < new Date(this.startDate)){
                        a.bf = a.bf? a.bf : new Date(e.end) >= new Date(uGetDateFormat_UTC(`yyyy-MM-DDT${a.txt}:29:59`, IEDate(this.targetDate))) ? e : null;
                        a.af = a.af? a.af : new Date(e.end) >= new Date(uGetDateFormat_UTC(`yyyy-MM-DDT${a.txt}:30:00`, IEDate(this.targetDate))) ? e : null;
                    }
                    else if((new Date(e.start).getHours() <= Number(a.txt) && new Date(e.end).getHours() >= Number(a.txt)) 
                            || new Date(e.end) >= new Date(this.endDate)){
                        a.bf = a.bf? a.bf :
                            (new Date(e.start) <= new Date(uGetDateFormat_UTC(`yyyy-MM-DDT${a.txt}:00:00`, IEDate(this.targetDate))) && new Date(e.end) >= new Date(uGetDateFormat_UTC(`yyyy-MM-DDT${a.txt}:29:59`, IEDate(this.targetDate)))) ? e : null;
                        a.af = a.af? a.af :
                            (new Date(e.start) <= new Date(uGetDateFormat_UTC(`yyyy-MM-DDT${a.txt}:30:00`, IEDate(this.targetDate))) && new Date(e.end) >= new Date(uGetDateFormat_UTC(`yyyy-MM-DDT${a.txt}:30:00`, IEDate(this.targetDate)))) ? e : null;
                    }
                })
            })
        }
    }

    setTimeArray(){
        this.timeArray.filter(t=> t.num>=6 && t.num<=21).map(a=>{
            if(a.num%1 == 0){
                var num = a.num<10? `0${a.num}` : a.num.toString()
                this.eventArray.push({
                    txt: num.substring(0,2),
                    bf: null,
                    af: null
                })
            }
        })
    }

    created() {
        this.onChangedTargetDate(this.targetDate);
        this.timeArray = uGetTimeArray([
            this.$t('W_AM').toString(),
            this.$t('W_PM').toString()
        ]);
        this.setTimeArray()
    }
}